import { compose } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../../common/react-redux';
import { shareBank, getSharedBanks, updateSharedBankPermission, getBank, updateBank, changeSharedBankLoading } from '../../api/banks';
import { removeSharedBank } from '../../../common/actions/sharedBanks';
import { withConfirm } from '../../../common/actions/modal';
import SharingModal from './presenter';
function mapStateToProps(state, ownProps) {
  var sharedBanks = state.get('sharedBanks', Map()).filter(function (sharedBank) {
    return sharedBank.get('bankId') === ownProps.bank.id;
  }).toList();
  var loading = state.getIn(['sharingModal', 'loading']);
  return {
    sharedBanks: sharedBanks,
    loading: loading
  };
}
var mapDispatchToProps = {
  shareBank: shareBank,
  getSharedBanks: getSharedBanks,
  updateSharedBankPermission: updateSharedBankPermission,
  getBank: getBank,
  removeSharedBank: removeSharedBank,
  updateBank: updateBank,
  withConfirm: withConfirm,
  changeSharedBankLoading: changeSharedBankLoading
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(SharingModal);